import { parse } from 'query-string';
import { includes } from 'lodash-es';
import { useLocation } from 'react-router-dom';
import dayjs from '@/services/tools/dayjs';
import { SHORT_DATE_FORMAT, TIME_RANGES } from '@/services/constants';
import { DateDropdownOptions } from '@/services/dictionaries/DateRangeValues';

export const useDateDropdownLabel = (defaultValue?: string, dateFrom?: string, dateTo?: string): string => {
    const location = useLocation();
    const query = parse(location.search);
    const dateRange = query?.daterange?.toString();
    const visibleFormat = 'DD MMM YYYY';

    const labels = {
        '7': 'last7days',
        '14': 'last14days',
        '30': 'last30days',
        '90': 'last3months',
        '180': 'last6months',
        '365': 'lastyear',
    };

    if (dateRange && dateRange !== DateDropdownOptions.Calendar) return dateRange;

    if (query.from && query.to || dateFrom && dateTo) {
        const from = dayjs((query.from ?? dateFrom) as string, SHORT_DATE_FORMAT);
        const to = dayjs((query.to ?? dateTo) as string, SHORT_DATE_FORMAT);
        const datesDiff = to.diff(from, 'day');

        if (includes(TIME_RANGES, datesDiff) && dayjs().isSame(to, 'day')) {
            return labels[datesDiff.toString()];
        } else {
            return `${from.add(1, 'day').utc().format(visibleFormat)} - ${to
                .add(1, 'day')
                .utc()
                .utc()
                .format(visibleFormat)}`;
        }
    }
    return defaultValue;
};
